import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Drug, DrugBackEndModel, DrugCode } from '../../models/drug';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { ProductType } from 'src/app/enum/product-type';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import * as _ from 'lodash-es';
import { PCTableOutputModel } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-drug-modal',
  templateUrl: './drug-modal.component.html',
  styleUrls: ['./drug-modal.component.css'],
})
export class DrugModalComponent implements OnChanges {
  constructor(
    private apiService: UserApiService,
    private logger: LoggerService
  ) {
    this.activeAddModal = true;
    this.thisValue = new Drug();
    this.thisBarcodeValue = new DrugCode();
    this.endPoint = 'Drug';
  }

  // #region Input Values
  @Input() activeAddModal: boolean;
  @Input() thisValue: Drug;
  @Input() productType?: ProductType;
  @Input() EditUrl?: string;
  // #endregion Input Values

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public thisBarcodeValue: DrugCode;
  public loadingModal: boolean = false;
  public endPoint: string;
  public productTypeList: any[] = Object.keys(ProductType)
    .filter((key) => !isNaN(Number(ProductType[key])))
    .map((key) => ({ value: ProductType[key], name: key }));

  // #region drop down Properties
  public genericDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugGeneric',
    'title',
    'title',
    false,
    true,
    true,
    true,
    false
  );

  public drugFormDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugForm',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public drugUsageDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugUsage',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public companyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public createCompanyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public countryDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Country',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public keepingTypeDropDown: DropDownPagingInput = new DropDownPagingInput(
    'keepingType',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );
  // #endregion;

  public clearEditItem() {
    this.thisValue = new Drug();

    this.thisValue.drugPackageCount = 1;

    this.genericDropDown.buttonClass = undefined;
    this.drugFormDropDown.buttonClass = undefined;
    this.createCompanyDropDown.buttonClass = undefined;
    this.drugFormDropDown.defaultValue = 'قرص';
    this.drugFormDropDown.defaultKey = 'a0d45e47-2dd7-42cf-a1d2-63dc2c1468c6';

    this.createCompanyDropDown.defaultValue = undefined;
    this.createCompanyDropDown.defaultKey = undefined;

    this.companyDropDown.defaultValue = undefined;
    this.companyDropDown.defaultKey = undefined;

    this.drugUsageDropDown.defaultValue = 'خوراکی';
    this.drugUsageDropDown.defaultKey = '25db3f75-d6e1-4bc2-bea5-2c990da90d9d';

    this.countryDropDown.defaultValue = 'ایران';
    this.countryDropDown.defaultKey = 'BBCEFAFD-88DD-4DF5-AA3F-763899168559';

    this.keepingTypeDropDown.defaultValue = 'دور از گرما و نور مستقیم خورشید';
    this.keepingTypeDropDown.defaultKey =
      '91d5519f-075d-46c2-bc46-f0aba2254f97';

    this.genericDropDown.defaultValue = undefined;
    this.genericDropDown.defaultKey = undefined;
  }

  public submit() {
    if (this.activeAddModal) {
      this.saveAdd();
    } else {
      this.saveEdit();
    }
  }

  public checkValidation(): boolean {
    const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
    const minLengthMessage = 'مقدار این فیلد نمیتواند کمتر از 3 کاراکتر باشد';
    let isSucceed = true;

    if (this.thisValue == null) {
      return false;
    }

    if (this.thisValue.name == null || this.thisValue.name == '') {
      this.thisValue.nameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.name.length < 3) {
      this.thisValue.nameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.nameHint = undefined;
    }

    if (
      this.thisValue.persianName == null ||
      this.thisValue.persianName == ''
    ) {
      this.thisValue.persianNameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.persianName.length < 3) {
      this.thisValue.persianNameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.persianNameHint = undefined;
    }

    // if (this.thisValue.erxCode == null || this.thisValue.erxCode == '') {
    //   this.thisValue.erxCodeHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.erxCode.length < 3) {
    //   this.thisValue.erxCodeHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.erxCodeHint = undefined;
    // }

    // if (this.thisValue.irc == null || this.thisValue.irc == '') {
    //   this.thisValue.ircHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.irc.length < 3) {
    //   this.thisValue.ircHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.ircHint = undefined;
    // }

    // if (this.thisValue.gtn == null || this.thisValue.gtn == '') {
    //   this.thisValue.gtnHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.gtn.length < 3) {
    //   this.thisValue.gtnHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.gtnHint = undefined;
    // }

    // if (this.pageName == 'Drug') {
    //   if (
    //     this.thisValue.drugGenericId == null ||
    //     this.thisValue.drugGenericId == ''
    //   ) {
    //     this.genericDropDown.buttonClass = 'is-invalid';
    //     this.thisValue.drugGenericHint = requiredMessage;
    //     isSucceed = false;
    //   } else {
    //     this.thisValue.drugGenericHint = undefined;
    //     this.drugFormDropDown.buttonClass = '';
    //   }
    // } else {
    //   this.thisValue.drugGenericId = '00000000-0000-0000-0000-000000000000';
    // }

    if (
      this.thisValue.drugFormId == null ||
      this.thisValue.drugFormId == ''
    ) {
      this.drugFormDropDown.buttonClass = 'is-invalid';
      this.thisValue.drugFormHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugFormHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    // if (
    //   this.thisValue.drugUsageId == null ||
    //   this.thisValue.drugUsageId == ''
    // ) {
    //   this.thisValue.drugUsageHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.drugUsageHint = undefined;
    // }

    if (
      this.thisValue.creatorCompanyId == null ||
      this.thisValue.creatorCompanyId == ''
    ) {
      this.createCompanyDropDown.buttonClass = 'is-invalid';
      this.thisValue.creatorCompanyHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.creatorCompanyHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    // if (
    //   this.thisValue.licenseCompanyId == null ||
    //   this.thisValue.licenseCompanyId == ''
    // ) {
    //   this.thisValue.licenseCompanyHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.licenseCompanyHint = undefined;
    // }

    // if (this.thisValue.countryId == null || this.thisValue.countryId == '') {
    //   this.thisValue.countryHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.countryHint = undefined;
    // }

    if (
      this.thisValue.drugPackageCount == null ||
      this.thisValue.drugPackageCount.toString() == '' ||
      this.thisValue.drugPackageCount == 0
    ) {
      this.thisValue.drugPackageHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugPackageHint = undefined;
    }

    // if (
    //   this.thisValue.keepingTypeId == null ||
    //   this.thisValue.keepingTypeId == ''
    // ) {
    //   this.thisValue.keepingTypeHint = requiredMessage;
    //   isSucceed = false;
    // } else {
    //   this.thisValue.keepingTypeHint = undefined;
    // }

    if (this.thisValue.buyPrice == null || this.thisValue.buyPrice == 0) {
      this.thisValue.buyPriceHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.buyPrice < 500) {
      this.thisValue.buyPriceHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.buyPriceHint = undefined;
    }

    if (this.thisValue.sellPrice == null || this.thisValue.sellPrice == 0) {
      this.thisValue.costHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.sellPrice < 500) {
      this.thisValue.costHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.costHint = undefined;
    }

    if (this.thisValue.productType == null) {
      this.logger.addError('Technical_Error', false);
      return false;
    }

    return isSucceed;
  }

  public saveAdd() {
    try {
      if (!this.checkValidation()) {
        return;
      }

      this.loadingModal = true;
      let url = `${this.endPoint}`;

      const backendJson = this.toJSON();

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (
            this.thisValue?.drugCodes != null &&
            this.thisValue.drugCodes.length > 0
          ) {
            this.addDrugCodeList(result.data.id);
            return;
          }

          this.completeSuccess(result.data);
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public addDrugCodeList(drugId: string) {
    try {
      this.loadingModal = true;

      if (this.thisValue == null) {
        return;
      }
      let url = `DrugCode/List`;

      const thisDrugCodeList: any[] = this.thisValue.drugCodes.map(
        (current) => ({
          erxCode: current.erxCode,
          irc: current.irc,
          gtn: current.gtn,
          barCode: current.barCode,
          drugId: drugId,
        })
      );

      console.log(thisDrugCodeList);

      this.apiService
        .postItem(new ApiRequestModel(url, thisDrugCodeList))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.completeSuccess();
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  private toJSON(): DrugBackEndModel {
    if (this.thisValue == null) {
      return new DrugBackEndModel();
    }
    var productType: number = +this.thisValue.productType!;

    let result: DrugBackEndModel = {
      name: this.thisValue.name,
      persianName: this.thisValue.persianName,
      attachment: this.thisValue.attachment,
      sellPrice: this.thisValue.sellPrice,
      buyPrice: this.thisValue.buyPrice,
      flavor: this.thisValue.flavor,
      drugGenericId: this.thisValue.drugGenericId,
      drugFormId: this.thisValue.drugFormId,
      drugUsageId: this.thisValue.drugUsageId,
      creatorCompanyId: this.thisValue.creatorCompanyId,
      countryId: this.thisValue.countryId,
      drugPackageCount: this.thisValue.drugPackageCount,
      keepingTypeId: this.thisValue.keepingTypeId,
      licenseCompanyId: this.thisValue.licenseCompanyId,
      productTypeEnum: productType,
    };

    if (
      productType != 0 &&
      (result.drugGenericId == null || result.drugGenericId == '')
    ) {
      result.drugGenericId = '00000000-0000-0000-0000-000000000000';
    }
    return result;
  }

  public saveEdit() {
    try {
      if (!this.checkValidation()) {
        return;
      }

      this.loadingModal = true;

      let url = `${this.endPoint}/${this.thisValue!.id}`;
      if (this.EditUrl != null && this.EditUrl != '') {
        url = `${this.EditUrl}/${this.thisValue!.id}`;
      }

      const backendJson = this.toJSON();

      this.apiService
        .patchItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            this.completeSuccess(result.data);
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public completeSuccess(modelData: any = null) {
    this.loadingModal = false;
    this.parentAction.next(new PCTableOutputModel('UpdateSuccess', modelData));
  }

  public checkDrugCodeValidation(): boolean {
    if (this.thisBarcodeValue == null || this.thisValue == null) {
      return false;
    }

    if (
      this.thisBarcodeValue.gtn == null &&
      this.thisBarcodeValue.erxCode == null &&
      this.thisBarcodeValue.irc == null &&
      this.thisBarcodeValue.barCode == null
    ) {
      return false;
    }
    return true;
  }

  public addDrugCode() {
    try {
      this.loadingModal = true;

      if (this.thisValue == null || !this.checkDrugCodeValidation()) {
        return;
      }
      let url = `DrugCode`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.thisBarcodeValue))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              if (this.thisValue != null) {
                this.thisValue.drugCodes.push(result.data);
                this.thisBarcodeValue = new DrugCode();
              }
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public addNewDrugCode(drugId?: string) {
    if (this.thisValue == null || !this.checkDrugCodeValidation()) {
      return;
    }

    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (this.thisBarcodeValue.gtn != null) {
      if (regexBarcode.test(this.thisBarcodeValue.gtn)) {
        const groups = this.thisBarcodeValue.gtn.match(regexBarcode)?.groups;
        this.thisBarcodeValue.gtn = _.cloneDeep(String(groups?.['GTN']));
      }
    }

    if (this.thisBarcodeValue.barCode != null) {
      if (regexBarcode.test(this.thisBarcodeValue.barCode)) {
        const groups =
          this.thisBarcodeValue.barCode.match(regexBarcode)?.groups;
        this.thisBarcodeValue.barCode = _.cloneDeep(String(groups?.['GTN']));
      }
    }

    if (drugId == null || drugId == '') {
      if (this.thisBarcodeValue.id == null) {
        const thisValue = _.cloneDeep(this.thisBarcodeValue);
        this.thisValue.drugCodes.push(thisValue);
        this.thisBarcodeValue = new DrugCode();
      } else {
        const index = _.cloneDeep(this.thisBarcodeValue.id);
        this.thisBarcodeValue.id = undefined;
        this.thisValue.drugCodes[index] = this.thisBarcodeValue;
        this.thisBarcodeValue = new DrugCode();
      }
    } else {
      this.thisBarcodeValue.drugId = drugId;
      if (this.thisBarcodeValue.id == null) {
        this.addDrugCode();
      } else {
        this.saveEditDrugCode();
      }
    }
  }

  public saveEditDrugCode() {
    try {
      if (
        this.thisBarcodeValue == null ||
        this.thisBarcodeValue.id == null ||
        !this.checkDrugCodeValidation()
      ) {
        return;
      }

      this.loadingModal = true;

      const thisValue = _.cloneDeep(this.thisBarcodeValue);

      let url = `DrugCode/${this.thisBarcodeValue.id}`;

      this.apiService.patchItem(new ApiRequestModel(url, thisValue)).subscribe(
        (result) => {
          if (result.succeeded && this.thisValue != null) {
            const index = this.thisValue.drugCodes.findIndex(
              (current) => current.id == result.data.id
            );

            this.thisValue.drugCodes[index] = result.data;
            this.thisBarcodeValue = new DrugCode();
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public editDrugCode(item: DrugCode, index: number) {
    try {
      if (this.thisValue?.id == null) {
        return;
      }
      item.drugId = this.thisValue.id;

      this.thisBarcodeValue = _.cloneDeep(item);

      if (this.thisBarcodeValue.id == null) {
        this.thisBarcodeValue.id = index.toString();
      }
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['activeAddModal'].currentValue == false &&
      changes['thisValue']?.currentValue != undefined
    ) {
      const thisValue = changes['thisValue'].currentValue;

      let productType: ProductType = thisValue.productTypeEnum;

      this.setProductType(productType);

      this.thisValue.productType = productType;

      this.genericDropDown.defaultValue = thisValue.drugGenericName;
      this.genericDropDown.defaultKey = thisValue.drugGenericId;

      this.drugFormDropDown.defaultValue = thisValue.drugFormName;
      this.drugFormDropDown.defaultKey = thisValue.drugFormId;

      this.drugUsageDropDown.defaultValue = thisValue.drugUsageName;
      this.drugUsageDropDown.defaultKey = thisValue.drugUsageId;

      this.companyDropDown.defaultValue = thisValue.licenseCompanyName;
      this.companyDropDown.defaultKey = thisValue.licenseCompanyId;

      this.createCompanyDropDown.defaultValue = thisValue.creatorCompanyName;
      this.createCompanyDropDown.defaultKey = thisValue.creatorCompanyId;

      this.countryDropDown.defaultValue = thisValue.countryName;
      this.countryDropDown.defaultKey = thisValue.countryId;

      this.keepingTypeDropDown.defaultValue = thisValue.keepingTypeName;
      this.keepingTypeDropDown.defaultKey = thisValue.keepingTypeId;
    } else if (
      changes['activeAddModal'].currentValue == true &&
      changes['productType']?.currentValue != null
    ) {
      this.clearEditItem();
      const productType: ProductType = changes['productType'].currentValue;
      this.thisValue.productType = productType;
      this.setProductType(productType);
    } else if (
      changes['activeAddModal'].currentValue == true &&
      changes['thisValue'].currentValue != undefined
    ) {
      const thisValue = changes['thisValue'].currentValue;
      this.clearEditItem();
      this.thisValue.persianName = thisValue.persianName;
      this.thisValue.name = thisValue.persianName;
    }
  }

  public setProductType(productType: ProductType) {
    if (this.productType != null) {
      if (productType == null) {
        productType = _.cloneDeep(this.productType);
      } else {
        if (productType != this.productType) {
          this.logger.addError('Technical_Error', false);
          return;
        }
      }
    } else {
      if (productType == null) {
        this.logger.addError('Technical_Error', false);
        return;
      }
    }

    switch (productType) {
      case ProductType.ChemicalDrug:
        this.endPoint = 'Drug';
        this.genericDropDown.isDisable = false;
        break;
      case ProductType.Essentials:
        this.endPoint = 'Essential';
        this.genericDropDown.isDisable = true;
        break;
      case ProductType.Cosmetic:
        this.endPoint = 'Cosmetic';
        this.genericDropDown.isDisable = true;
        break;
      case ProductType.MilkPowder:
        this.endPoint = 'MilkPowder';
        this.genericDropDown.isDisable = true;
        break;
      case ProductType.NaturalRemedy:
        this.endPoint = 'NaturalRemedy';
        this.genericDropDown.isDisable = true;
        break;
      case ProductType.Supplement:
        this.endPoint = 'Supplement';
        this.genericDropDown.isDisable = true;
        break;
      case ProductType.TraditionalDrug:
        this.endPoint = 'TraditionalDrug';
        this.genericDropDown.isDisable = true;
        break;
      default:
        this.logger.addError('Technical_Error', false);
        return;
    }
  }

  public closeModal() {
    this.parentAction.next(new PCTableOutputModel('CloseModal', null));
  }

  public getGenericList() {
    if (this.thisValue.productType == null) {
      this.thisValue.productType = 0;
    }
    const productType =
      ProductType[
        <keyof typeof ProductType>ProductType[this.thisValue!.productType]
      ];

    switch (productType) {
      case ProductType.ChemicalDrug:
        this.endPoint = `Drug`;
        this.genericDropDown.isDisable = false;
        break;

      case ProductType.Cosmetic:
        this.endPoint = `Cosmetic`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.Essentials:
        this.endPoint = `Essential`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.NaturalRemedy:
        this.endPoint = `NaturalRemedy`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.Supplement:
        this.endPoint = `Supplement`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.TraditionalDrug:
        this.endPoint = `TraditionalDrug`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.MilkPowder:
        this.endPoint = `MilkPowder`;
        this.genericDropDown.isDisable = true;
        break;

      default:
        this.endPoint = `Drug`;
        this.genericDropDown.isDisable = false;
        break;
    }
  }
}
